import { useAppDispatch } from '@/state/hooks';
import { openHelper } from '@/state/reducers/helperSlice';
import useLanguage from '@/utils/hooks/useLanguage';
import { MdOutlineHelpOutline } from 'react-icons/md';

const HelperLauncher = () => {
    const dispatch = useAppDispatch();
    const lang = useLanguage();

    return (
        <button
            type="button"
            title={lang.navigation.helper}
            className="fixed bottom-4 right-4 z-[101] rounded-full bg-brand-primary hover:bg-brand-primary-light text-brand-module-title shadow-lg px-4 py-3 flex items-center gap-2"
            onClick={() => dispatch(openHelper())}>
            <MdOutlineHelpOutline className="w-5 h-5" />
            <span className="text-sm font-semibold">{lang.navigation.helper}</span>
        </button>
    );
};

export default HelperLauncher;
